/* global $, $$ */ /* Bliss */
export class ArticleRating {
  constructor(el) {
    this.el = el
    this.form = $('form', this.el)
    this.votes = $$('.vote', this.el)
    this.message = $('.rating-response', this.el)
    /* eslint-disable-next-line */
    if (this.el.dataset.hasOwnProperty('ratingActivated')) {
      this.el.addEventListener('click', this.setRating.bind(this))
    }

    $('.rating-delete', this.el).addEventListener(
      'click',
      this.clearRating.bind(this)
    )

    this.updateVotes()

    if (Number.parseInt(this.form.rating.value, 10) > 0) {
      this.el.classList.add('article__rating--rated')
      this.message.innerText =
        'Deine aktuelle Bewertung: ' + this.form.rating.value
    }
  }

  clearRating() {
    this.form.rating.value = 0
    this.sendRating()
  }

  setRating(event) {
    // check if clicked on a vote item
    if (event.target && event.target.classList.contains('vote')) {
      let newRating = Number.parseInt(event.target.dataset.ratingValue, 10)

      this.form.rating.value = newRating
      this.sendRating()
    }
  }

  sendRating() {
    let data = []

    for (let i = 0; i < this.form.elements.length; i++) {
      data.push(
        encodeURIComponent(this.form.elements[i].name) +
          '=' +
          encodeURIComponent(this.form.elements[i].value)
      )
    }

    this.el.classList.add('waiting-for-response')

    if (this.form.rating.value > 0) {
      this.message.innerText = 'Speichern ...'
    } else {
      this.message.innerText = 'Löschen ...'
    }

    $.fetch(this.form.action, {
      method: 'POST',
      data: data.join('&'),
      timeout: 5000,
      responseType: 'json',
    })
      .then(fetchSuccess.bind(this))
      .catch(fetchError.bind(this))

    function fetchSuccess(xhr) {
      // delay a bit for 'slow' user
      setTimeout(() => {
        this.el.classList.remove('waiting-for-response')

        if (xhr.response.result == 'success') {
          // update rating value
          this.form.rating.value = xhr.response.rating
          this.updateVotes()
          if (xhr.response.rating != 0) {
            this.el.classList.add('article__rating--rated')
            this.message.innerText = 'Deine Bewertung wurde gespeichert!'
          } else {
            this.el.classList.remove('article__rating--rated')
            this.message.innerText = 'Deine Bewertung wurde entfernt.'
          }
        } else {
          this.message.innerText =
            'Leider konnte deine Bewertung nicht übermittelt werden. Versuche es später nochmals.'
        }
      }, 500)
    }

    function fetchError(/* error */) {
      this.el.classList.remove('waiting-for-response')
      this.message.innerText =
        'Leider konnte deine Bewertung nicht übermittelt werden. Versuche es später nochmals.'
    }
  }

  updateVotes(classForActive = 'active') {
    this.votes.forEach(vote => {
      if (
        Number.parseInt(vote.dataset.ratingValue, 10) <=
        Number.parseInt(this.form.rating.value, 10)
      ) {
        vote.classList.add(classForActive)
      } else {
        vote.classList.remove(classForActive)
      }
    })
  }
}
